import { render, staticRenderFns } from "./drag-zone.vue?vue&type=template&id=f8d80210&"
import script from "./drag-zone.vue?vue&type=script&lang=js&"
export * from "./drag-zone.vue?vue&type=script&lang=js&"
import style0 from "./drag-zone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports